import { IconComponent } from './types';

const PatternIcon: IconComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={13}
    height={3}
    fill="none"
    viewBox="0 0 13 3"
    {...props}
  >
    <path
      fill="currentColor"
      d="M2.667 1.474a1.334 1.334 0 1 1-2.667 0 1.334 1.334 0 0 1 2.667 0Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m6.82.06 1.273 1.272a.2.2 0 0 1 0 .283L6.82 2.888a.2.2 0 0 1-.283-.283l.932-.931H5.117v-.4H7.47L6.537.342A.2.2 0 1 1 6.82.059Z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5.282 2.888 4.01 1.615a.2.2 0 0 1 0-.283L5.282.058a.2.2 0 1 1 .283.283l-.931.932h2.351v.4H4.634l.931.932a.2.2 0 1 1-.283.283Z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M12.117 1.474a1.334 1.334 0 1 1-2.667 0 1.334 1.334 0 0 1 2.667 0Z"
    />
  </svg>
);
export default PatternIcon;
